module.exports = __webpack_public_path__ + "vue-app/img/big-3.51fc44be.jpg";